import React from 'react';
import './Advantages.scss';
import './Advantages-media.scss';
import TermsDelivery from '../TermsDelivery/TermsDelivery';
import { IAdvantages } from './interfaces';

const Advantages = ({ title, text, list }: IAdvantages) => {
  return (
    <div className="advantages">
      <h2 className="advantages__title">{title}</h2>
      <p className="body1 advantages__text">{text}</p>

      <ul className="advantages__columns">
        {list.map((item, i) => (
          <li className="advantages__li" key={i}>
            {item.text}
          </li>
        ))}
      </ul>

      <TermsDelivery/>
    </div>
  );
};

export default Advantages;
